import { render, staticRenderFns } from "./WalletCouponSend.vue?vue&type=template&id=f76eff52&scoped=true&"
import script from "./WalletCouponSend.vue?vue&type=script&lang=js&"
export * from "./WalletCouponSend.vue?vue&type=script&lang=js&"
import style0 from "./WalletCouponSend.vue?vue&type=style&index=0&id=f76eff52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76eff52",
  null
  
)

export default component.exports